import React, { ReactNode } from 'react'

import { CloseButton, Group, Stack } from '@mantine/core'

import { FaIcon } from '#components/FaIcon'

import styles from './Panel.module.css'

type PanelProps = React.PropsWithChildren<{
  header: ReactNode
  onClose(): void
}>

export function Panel(props: PanelProps) {
  return (
    <Stack
      className={styles.wrapper}
      component="aside"
      gap={0}
      w={350}
      h="100%"
    >
      <Group
        className={styles.header}
        justify="space-between"
        ps={10}
        pe={5}
        py={5}
        gap={4}
      >
        {props.header}{' '}
        <CloseButton
          className={styles.close}
          icon={<FaIcon icon="fa-xmark" size="16" />}
          onClick={props.onClose}
        />
      </Group>
      {props.children}
    </Stack>
  )
}
